import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-md mx-auto px-4 py-24 text-center animate-fade-up" data-testid="payment-cancel">
      <div className="w-16 h-16 rounded-2xl bg-secondary flex items-center justify-center mx-auto mb-6">
        <XCircle className="w-9 h-9 text-muted-foreground" />
      </div>
      <h1 className="font-display text-2xl font-bold mb-3">Checkout cancelled</h1>
      <p className="text-muted-foreground mb-8">No charge was made. You can pick up where you left off any time.</p>
      <div className="flex gap-3 justify-center">
        <Button asChild><Link to="/pricing">View plans</Link></Button>
        <Button variant="outline" asChild><Link to="/resources">Browse resources</Link></Button>
      </div>
    </div>
  );
}
